import type { AnnotationKey, AnnotationValues, SourceAnnotation } from '../../api/authorInsights'

export interface AnnotationDraft {
  revision: number
  values: AnnotationValues
  reset: AnnotationKey[]
  changed: AnnotationKey[]
}

function copyValue(value: AnnotationValues[AnnotationKey]) {
  return Array.isArray(value) ? [...value] : value
}

export function createAnnotationDraft(annotation: SourceAnnotation): AnnotationDraft {
  return { revision: annotation.revision, values: { ...annotation.values, secondary_topic_ids: [...annotation.values.secondary_topic_ids] }, reset: [], changed: [] }
}

/** При сверке сохраняем свои правки, а снятые overrides показывают новый AI-вариант. */
export function rebaseAnnotationDraft(draft: AnnotationDraft, fresh: SourceAnnotation): AnnotationDraft {
  const changed = new Set(draft.changed)
  const reset = new Set(draft.reset)
  const values = Object.fromEntries((Object.keys(fresh.values) as AnnotationKey[]).map((key) => [
    key,
    copyValue(reset.has(key) ? fresh.auto_values[key] : changed.has(key) ? draft.values[key] : fresh.values[key]),
  ])) as unknown as AnnotationValues
  return { ...draft, revision: fresh.revision, values }
}
